export function validatePhoneNumber(phoneNumber, countryCode) {
  console.log('countryCode',countryCode)
  // 移除区号中可能包含的加号、空格和括号等特殊字符
  const cleanCountryCode = countryCode.replace(/[^\d]/g, '');
  
  // 根据国家区号构建对应的手机号码正则表达式
  let phoneRegex;
  switch (cleanCountryCode) {
    case '86': // 中国大陆
      phoneRegex = /^1\d{10}$/;
      break;
    // 添加更多国家或地区的手机号码正则表达式
    default:
      return true; // 无法识别的区号，直接返回 false
  }
  
  // 使用正则表达式进行手机号码校验
  return phoneRegex.test(phoneNumber);
}

/**
 * 
 * @param {String} url 
 */
export function changeOssFileUrl(url) {
  // // 如果是本地坏境，改成代理访问， 代理在  vue.config.js 文件里面配置
  // if (process.env.NODE_ENV === 'development' && url) {
  //   // url = url.replace(/https:\/\/jianpin-oss\.adnonstop\.cn\/jianpin-dh\/resource/g, "/resource");
  //   url = url.replace(/https:\/\/jianpin-oss\.adnonstop\.cn\/jianpin-dh/g, "/jianpin-dh");
  // }

  return url;
}

/**
 * 本地地址替换为线上
 * @param {*} url 
 * @returns 
 */
export function changeLocalUrl(url) {
  // if (process.env.NODE_ENV === 'development' && url) {
  //   // return url.replace(/http:\/\/.*?\/resource/g, 'https://jianpin-oss.adnonstop.cn/jianpin-dh/resource')
  //   url = url.replace(/(http|https):\/\/.*?\/jianpin-dh/g, 'https://jianpin-oss.adnonstop.cn/jianpin-dh')
  // }
  return url
}

/**
 * 修改模板数据里面远程资源文件（OSS） url
 * 
 * @param {Object} template 
 */
export function changeTemplateJsonOssFileUrl(template) {
  let {objects} = template;

  if (objects) {
    objects = changeObjectsOssFileUrl(objects);
    template.objects = objects;
  }

  return template;
}

function changeObjectsOssFileUrl(objects) {
  for (let index = 0; index < objects.length; index++) {
    const object = objects[index];

    if (object.type == 'image') {
      object.src = changeOssFileUrl(object.src);
    }

    if (object.fill && typeof object.fill === 'object' && object.fill.type === 'pattern') {
      object.fill.source = changeOssFileUrl(object.fill.source);
    }

    if (object.type == 'group') {
      object.objects = changeObjectsOssFileUrl(object.objects);
    }

    objects[index] = object;
  }

  return objects;
}